import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { isFutureMonth } from '../../lib/dateOrderCheck';
import Select from '../Select';

const errorClass = 'has-error';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const placeholder = label => ({ value: '', label });

const monthOptions = () => {
  const months = monthNames.map((name, index) => {
    return {
      value: index.toString(),
      label: name,
    };
  });

  return [placeholder('Month'), ...months];
};

const yearOptions = (maxYear, minYear) => {
  const yearRange = maxYear - minYear + 1;
  const years = [...Array(yearRange).keys()].map(i => {
    const year = (maxYear - i).toString();

    return { value: year, label: year };
  });

  return [placeholder('Year'), ...years];
};

const checkDates = (allowFutureDates, setDateError, month, year, nowDate) => {
  if (allowFutureDates === false) {
    const paramMonth = parseInt(month, 10);
    const paramYear = parseInt(year, 10);
    if (
      paramMonth &&
      paramYear &&
      isFutureMonth(nowDate.getMonth(), nowDate.getFullYear(), paramMonth, paramYear)
    ) {
      setDateError('Date cannot be in the future');
    } else {
      setDateError('');
    }
  }
};

const YearMonthPicker = ({
  month,
  year,
  minYear,
  maxYear,
  hasError,
  errorMessage,
  onMonthChange,
  onYearChange,
  yearId,
  monthId,
  allowFutureDates,
  disabled,
}) => {
  const [dateError, setDateError] = useState('');
  useEffect(() => {
    const nowDate = new Date(Date.now());
    checkDates(allowFutureDates, setDateError, month, year, nowDate);
  }, [allowFutureDates, month, year]);
  const showErrorMessage = errorMessage.trim().length > 0 || dateError.trim().length > 0;
  const showErrorStyling = hasError || dateError ? true : showErrorMessage;

  const renderError = () => {
    if (showErrorMessage) {
      const concatErrorMessage = `${errorMessage}${
        errorMessage && dateError ? ' ' : ''
      }${dateError}`;
      return <div className="text-error">{concatErrorMessage}</div>;
    }

    return null;
  };

  return (
    <>
      <div className="row">
        <div className="col col--10/16-small">
          <Select
            id={monthId}
            className={showErrorStyling ? errorClass : ''}
            value={month}
            options={monthOptions()}
            onChange={onMonthChange}
            disabled={disabled}
          />
        </div>

        <div className="col col--fill">
          <Select
            id={yearId}
            className={showErrorStyling ? errorClass : ''}
            value={year}
            options={yearOptions(maxYear, minYear)}
            onChange={onYearChange}
            disabled={disabled}
          />
        </div>
      </div>
      {renderError()}
    </>
  );
};

YearMonthPicker.propTypes = {
  month: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  minYear: PropTypes.number.isRequired,
  maxYear: PropTypes.number.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  yearId: PropTypes.string,
  monthId: PropTypes.string,
  allowFutureDates: PropTypes.bool,
  disabled: PropTypes.bool,
};

YearMonthPicker.defaultProps = {
  hasError: false,
  errorMessage: '',
  yearId: 'year-picker',
  monthId: 'month-picker',
  allowFutureDates: true,
  disiabled: false,
};

export default YearMonthPicker;
